//Styles
import "./Footer.css";

import React from "react";
export default function Footer() {
  return <footer>Made with ❤️ by <a href="https://www.bbacim.com">Bacim</a></footer>;
}
